const blogcategory = {
  getlist: 'blogcategory/getlist-by-admin',
  add: 'blogcategory/add',
  update: 'blogcategory/update',
  remove: 'blogcategory/remove',
  get: 'blogcategory/get',
  getall: 'blogcategory/getall-by-admin',
  clearcache: 'blogcategory/clear-cache',
}
export default blogcategory
